import { useEffect, useRef, useState } from "react";
import { MenuBar } from "./components/MenuBar";
import { Toolbar } from "./components/Toolbar";
import { UploadPanel } from "./components/UploadPanel";
import { Viewport } from "./components/Viewport";
import { PropertiesPanel } from "./components/PropertiesPanel";
import { useSceneStore } from "./store/sceneStore";
import { useAutosave } from "./hooks/useAutosave";
import { useUndoSafetyNet } from "./hooks/useUndoSafetyNet";
import { loadSceneFromIndexedDb } from "./store/persistence";
import { fetchSharedScene } from "./lib/share";

export default function App() {
  const loadScene = useSceneStore((s) => s.loadScene);
  const [status, setStatus] = useState<string>("");
  const initialized = useRef(false);

  useAutosave();
  useUndoSafetyNet();

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    const match = window.location.pathname.match(/^\/s\/([\w-]+)$/);
    if (match) {
      setStatus("Lade geteilte Szene…");
      fetchSharedScene(match[1])
        .then((scene) => {
          loadScene(scene.objects, scene.settings);
          setStatus("Geteilte Szene geladen");
          window.history.replaceState({}, "", "/");
        })
        .catch(() => setStatus("Geteilte Szene konnte nicht geladen werden"))
        .finally(() => window.setTimeout(() => setStatus(""), 3000));
      return;
    }

    loadSceneFromIndexedDb().then((persisted) => {
      if (persisted && persisted.objects.length > 0) {
        loadScene(persisted.objects, persisted.settings);
      }
    });
  }, [loadScene]);

  return (
    <div className="app-layout">
      <MenuBar />
      <div className="toolbar-row">
        <Toolbar />
        {status && <span className="status-text">{status}</span>}
      </div>
      <UploadPanel />
      <Viewport />
      <PropertiesPanel />
    </div>
  );
}
